module.exports = __webpack_public_path__ + "img/index-security-bottom1.7f57f51c.svg";